import type {
  PanelBillingMode,
  PanelComponentBillingPolicy,
  PanelDefinition,
  PanelWorkflowKind,
  SavePanelInput,
} from "../../../services/admin/panels.service";

export interface PanelSelectOption {
  value: string;
  label: string;
}

export interface PanelComponentFormValue {
  stainId: string;
  quantity: number;
  billingPolicy: PanelComponentBillingPolicy;
  overrideCptId: string;
}

export interface PanelFormValues {
  name: string;
  description: string;
  workflowKind: PanelWorkflowKind;
  billingMode: PanelBillingMode;
  groupCptId: string;
  components: PanelComponentFormValue[];
}

export const EMPTY_PANEL_COMPONENT: PanelComponentFormValue = {
  stainId: "",
  quantity: 1,
  billingPolicy: "standard",
  overrideCptId: "",
};

export function getPanelFormValues(panel?: PanelDefinition): PanelFormValues {
  if (!panel) {
    return {
      name: "",
      description: "",
      workflowKind: "ordinary",
      billingMode: "individual_only",
      groupCptId: "",
      components: [{ ...EMPTY_PANEL_COMPONENT }],
    };
  }
  return {
    name: panel.name,
    description: panel.description ?? "",
    workflowKind: panel.workflowKind,
    billingMode: panel.billingMode,
    groupCptId: panel.groupCptId ?? "",
    components: panel.components.map((component) => ({
      stainId: component.stainId,
      quantity: component.quantity,
      billingPolicy: component.billingPolicy,
      overrideCptId: component.overrideCptId ?? "",
    })),
  };
}

export function toSavePanelInput(values: PanelFormValues): SavePanelInput {
  return {
    name: values.name.trim(),
    description: values.description.trim() || null,
    workflowKind: values.workflowKind,
    billingMode: values.billingMode,
    groupCptId: values.groupCptId || null,
    components: values.components.map((component) => ({
      stainId: component.stainId,
      quantity: Number(component.quantity),
      billingPolicy: component.billingPolicy,
      overrideCptId: component.overrideCptId || null,
    })),
  };
}

export function normalizeComponentPolicy(
  billingMode: PanelBillingMode,
  component: PanelComponentFormValue
): PanelComponentFormValue {
  if (billingMode === "group_only") {
    return { ...component, billingPolicy: "none", overrideCptId: "" };
  }
  if (billingMode === "individual_only") {
    return { ...component, billingPolicy: "standard", overrideCptId: "" };
  }
  return component;
}
